import React, { useMemo, useState, useEffect, useCallback } from "react";
import { Table } from "../../Components/Table/Table";
import toast from "react-hot-toast";
import { getSalaryList } from "../../api/salary";

const Employee_Salary = () => {
  const [pageno, setPageno] = useState(1);
  const [data, setData] = useState([]);
  const [employeeId, setEmployeeId] = useState("");

  /* ================= GET EMPLOYEE ID ================= */
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (user?.employeeId) {
      setEmployeeId(user.employeeId);
    } else {
      toast.error("Employee not found ❌");
    }
  }, []);

  /* ================= FETCH SALARY ================= */
  const fetchSalary = useCallback(async () => {
    if (!employeeId) return;

    try {
      const res = await getSalaryList({ employeeId });

      const list = res?.data?.data || [];

      const formatted = list.map((item, index) => ({
        ...item,
        sno: index + 1,
      }));

      setData(formatted);

      if (list.length === 0) {
        toast("No salary data found ⚠️");
      } else {
        toast.success("Salary loaded ✅");
      }
    } catch (error) {
      toast.error("Failed to load salary ❌");
    }
  }, [employeeId]);

  /* ================= AUTO FETCH ================= */
  useEffect(() => {
    fetchSalary();
  }, [fetchSalary]);

  /* ================= COLUMNS ================= */
  const columns = useMemo(
    () => [
      { Header: "S.No", accessor: "sno" },
      { Header: "Month", accessor: "month" },
      { Header: "Year", accessor: "year" },
      { Header: "Credit Date", accessor: "creditDate" },
      { Header: "Time", accessor: "creditTime" },
      { Header: "Amount", accessor: "amount" },
      { Header: "Company Bank", accessor: "companyBank" },
      { Header: "Employee Bank", accessor: "employeeBank" },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => (
          <span
            style={{
              color: value === "Credited" ? "green" : "red",
              fontWeight: "bold",
            }}
          >
            {value}
          </span>
        ),
      },
    ],
    []
  );

  return (
    <div className="container mt-3">
      <h3>My Salary</h3>

      <Table
        columns={columns}
        data={data}
        pageno={pageno}
        setPageno={setPageno}
        show
      />
    </div>
  );
};

export default Employee_Salary;